<template>
  <div class="event-box">
    <div class="c-ttl-wrap">
      <div class="c-ttl fix" :class="currentDate ? 'c-d-ttl' : 'c-m-ttl'" @click="$emit('cancelDate')">
        {{ listTitle }}
      </div>
    </div>
    <div v-if="tgts.length == 0" class="c-no-ev">
      {{ $T('common.no_data') }}
    </div>
    <div v-else class="event-detail">
      <v-layout row>
        <v-flex>
          <v-list three-line>
            <template v-for="(event, index) in list">
              <v-divider v-if="index > 0" :inset="sameWithPrev(list, index)" :key="index" class="c-div"></v-divider>

              <v-list-tile avatar @click="eventClick(event)" class="c-m-r">
                <v-list-tile-avatar
                  class="c-icon-area"
                  :class="currentDate ? 'c-tm' : ''"
                  v-html="sameWithPrev(list, index) ? '' : toIconArea(event)"
                >
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>{{ event.title }}</v-list-tile-title>
                  <v-list-tile-sub-title v-if="!currentDate" class="c-st">
                    <v-icon class="c-i">access_time</v-icon><span>{{ toTimeArea(event) }}</span>
                  </v-list-tile-sub-title>
                  <v-list-tile-sub-title class="c-st">
                    <template v-if="event.location">
                      <div @click.stop="goLocation(event.location)">
                        <v-icon class="c-i">location_on</v-icon><span>{{ event.location }}</span>
                      </div>
                    </template>
                  </v-list-tile-sub-title>
                  <v-list-tile-sub-title v-if="currentDate" class="c-st">
                    <template v-if="event.item.desc">
                      <span>{{ event.item.desc }}</span>
                    </template>
                  </v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <community-chip-s :onlyicon="leTbS" :cid="event.item.community_id" />
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list>
          <tail-loader v-if="tgts" :srcs="tgts" :unit="5" v-model="list" />
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  props: ['events', 'currentDate', 'ym'],
  data() {
    return {
      tgts: this.getTargets(this.events, this.currentDate),
      list: [],
    };
  },
  watch: {
    currentDate(n, o) {
      this.tgts = this.getTargets(this.events, n);
      this.$store.commit('SET_TABYM_ADJUST', time());
    },
    eventCount(n, o) {
      this.tgts = this.getTargets(this.events, this.currentDate);
    },
    list(n, o) {
      this.$store.commit('SET_TABYM_ADJUST', time());
    },
  },
  computed: {
    listTitle() {
      var tgt;
      if (this.currentDate) {
        var m = this.$moment(this.currentDate, 'YYYY-MM-DD');
        if (this.isUsFormat) {
          tgt = m.format($T('common.moment.us.mdw'));
        } else {
          tgt = m.format($T('common.moment.mdw'));
        }
      } else {
        tgt = this.$moment(this.ym, 'YYYYMM').format($T('common.moment.m'));
      }
      return $T('page.cal.list.title', { tgt: tgt });
    },
    eventCount() {
      return this.events.length;
    },
    today() {
      return this.currentDate || null;
    },
    tommorow() {
      if (!this.currentDate) return null;
      return this.$moment.unix(this.$moment(this.currentDate).unix() + 60 * 60 * 24).format('YYYY-MM-DD');
    },
    monthStart() {
      return this.$moment(this.ym, 'YYYYMM').format('YYYY-MM-DD');
    },
    monthEnd() {
      return this.$moment(this.ym, 'YYYYMM')
        .add(1, 'M')
        .format('YYYY-MM-DD');
    },
  },
  methods: {
    eventClick(event) {
      this.$emit('eventClick', event);
    },
    getTargets(events, current) {
      var tgts = [];
      if (this.currentDate) {
        var today = this.$moment(this.currentDate);
        var tommorow = this.$moment.unix(today.unix() + 24 * 60 * 60);
        today = today.format('YYYY-MM-DD');
        tommorow = tommorow.format('YYYY-MM-DD');
        for (var event of events) {
          if (event.start < tommorow && event.end >= today) tgts.push(event);
        }
      } else {
        for (var event of events) {
          if (!event.outOfMonth) tgts.push(event);
        }
      }

      if (this.currentDate) {
        tgts.sort(function(a, b) {
          if (a.allDay) {
            if (b.allDay) {
              if (a.start != b.start) return a.start < b.start ? -1 : 1;
              if (a.endD != b.endD) return a.endD < b.endD ? 1 : -1;
              return a.id < b.id ? 1 : -1;
            }
            return -1;
          }
          if (b.allDay) return 1;
          if (a.start != b.start) return a.start < b.start ? -1 : 1;
          if (a.endD != b.endD) return a.endD < b.endD ? 1 : -1;
          return a.id < b.id ? 1 : -1;
        });
      } else {
        tgts.sort(function(a, b) {
          if (a.start != b.start) return a.start < b.start ? -1 : 1;
          if (a.endD != b.endD) return a.endD < b.endD ? 1 : -1;
          return a.id < b.id ? 1 : -1;
        });
      }
      return tgts;
    },
    sameWithPrev(events, i) {
      if (i == 0) return false;
      return this.toIconArea(events[i]) == this.toIconArea(events[i - 1]);
    },
    toIconArea(event) {
      var ms = this.$moment(event.allDay ? event.startD : event.start);
      var me = this.$moment(event.endD);
      if (this.currentDate) {
        // for date
        if (event.allDay) return this.toTag(0, 0, '');
        var s = ms.format('YYYY-MM-DD') < this.today ? 0 : ms.format('HH:mm');
        var e = this.tommorow <= me.format('YYYY-MM-DD') ? 0 : me.format('HH:mm');
        return this.toTag(s, e, '');
      }

      // for month
      var s = ms.format('YYYY-MM-DD') < this.monthStart ? 0 : ms.format('D');
      var e = this.monthEnd <= me.format('YYYY-MM-DD') ? 0 : me.format('D');
      return this.toTag(s, e, '');
    },
    toTimeArea(event) {
      var ms = this.$moment(event.allDay ? event.startD : event.start);
      var me = this.$moment(event.endD);
      var msD = ms.format('YYYY-MM-DD');
      var meD = me.format('YYYY-MM-DD');
      if (msD == meD) {
        if (event.allDay) return $T('common.all_day');
        return `${ms.format('HH:mm')} - ${me.format('HH:mm')}`;
      }
      if (event.allDay) return `${msD} - ${meD}`;
      return `${ms.format('MM-DD HH:mm')} - ${me.format('MM-DD HH:mm')}`;
    },
    toArea2(event) {},
    toTag(s, e, def) {
      if (s) {
        if (s == e) return `<div class="se">${s}</div>`;
        if (e) return `<div class="se">${s}</div><div class="md">-</div><div class="se">${e}</div>`;
        return `<div class="se">${s}</div><div class="md">-</div>`;
      }
      if (e) return `<div class="md">-</div><div class="se">${e}</div>`;
      return `<div class="def">${def}</div>`;
    },
    goLocation(loc) {
      if (!loc) return;
      // window.open(this.$utils.toMapUrl(loc), '_gmap');
      window.open(this.$utils.toMapUrl(loc));
    },
  },
};
</script>

<style scoped>
.c-ttl-wrap {
  height: 31px;
  position: relative;
}
.c-ttl {
  position: absolute;
  top: -1px;
  left: 0;
  z-index: 5;
  border-top: 1px solid #bdbdbd;
  border-bottom: 1px solid #bdbdbd;
  width: 100%;
  height: 30px;
  font-weight: 600;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.28);
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.c-m-ttl {
  background-color: #fff;
}
.c-d-ttl {
  background-color: #ddf3f6;
}
.c-no-ev {
  height: 80px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.54);
  display: flex;
  justify-content: center;
  align-items: center;
}
.c-icon-area {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  font-weight: 600;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.28);
  font-size: 16px;
  min-height: 40px;
  width: 60px;
}
.c-st {
  min-height: 18px;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
}
.c-icon-area.c-tm {
  font-size: 14px;
}
.c-i {
  font-size: 14px;
  margin-right: 2px;
}
.c-div {
}
.c-div.v-divider--inset {
  margin-left: 60px !important;
  max-width: calc(100% - 60px) !important;
}

.event-detail {
  margin-bottom: 0px;
}
.event-list-date {
  width: 10%;
}

.event-list-info {
  width: 80%;
}

.le-tbs .v-list__tile__action {
  width: 35px;
  max-width: 35px;
  min-width: 35px;
}

.event-list-detail-box {
  cursor: pointer;
}
.v-list {
  padding: 0 !important;
}
</style>
